import setRuleForSelector from './set-rule-for-selector';

const BLOCK_ID_REGEXP = /#([^\s]*)/;

const copyCssTextForBlocks = (blocksIdsReferenceMap, customStylesheet) => {
  const sourcePageRules = [...customStylesheet.cssRules].filter((rule) =>
    Object.keys(blocksIdsReferenceMap).some((blockId) =>
      rule.selectorText.startsWith(`#${blockId}`)
    )
  );

  sourcePageRules.forEach((rule) => {
    const {
      selectorText,
      style: { cssText: blockRule },
    } = rule;

    const sourceBlockId = selectorText.match(BLOCK_ID_REGEXP)[1];

    setRuleForSelector(
      selectorText.replace(sourceBlockId, blocksIdsReferenceMap[sourceBlockId]),
      customStylesheet,
      blockRule
    );
  });
};

export default copyCssTextForBlocks;
